import { useCallback, useEffect, useMemo } from 'react';

export default function useNewMessageNotifier(host) {
  const newMessageSound = useMemo(() => new Audio(`${host}/sounds/new_message.mp3`), [host]);

  const playSound = useCallback(() => {
    newMessageSound.play();
  }, [newMessageSound]);

  useEffect(() => () => {
    window.removeEventListener('s2:widget:message:new', playSound);
  }, [playSound]);

  const init = useCallback(() => {
    window.addEventListener('s2:widget:message:new', playSound);
  }, [playSound]);

  return {
    init,
  };
}
